<template>
    <div>
        <div v-if="showWarning" class="z-5 absoluteCenter">
            <slot></slot>  
        </div>
        <Overlay :show="showWarning"/>
    </div>
</template>

<script>
import Overlay from '@/components/layout/Overlay.vue';

export default {
    components: {
        Overlay
    },
    props: {
        showWarning: {
            type: Boolean
        }
    }
};
</script>
